export default function (state, quoteType, is02Meter, referrerBranchCode, switchOwnerReference) {
  let economy7Percentage = {};
  if (is02Meter) {
    economy7Percentage = { economy7Percentage: state.economy7Percentage };
  }

  const electricityUsage = state.electricityUsage.usage ? parseInt(state.electricityUsage.usage) : 0;
  const gasUsage = state.gasUsage.usage ? parseInt(state.gasUsage.usage) : 0;
  const findGasMeter = state.address.parts.gasdetails.find(({ isDomestic }) => isDomestic);
  const findElectricityMeter = state.address.parts.elecdetails.find(({ isDomestic }) => isDomestic);
  const mpan = findElectricityMeter ? findElectricityMeter.mpan : null;
  const mprn = findGasMeter ? findGasMeter.mprn : null

  const modelObject = {
    switchType: quoteType,
    postcode: state.postcode,
    address: {
      ...state.address.parts,
      town: state.address.parts.city || state.address.parts.town,
      mpan,
      mprn
    },
    billConsumptionIsEstimated: true,
    ...economy7Percentage,
    referrerBranchCode,
    switchOwnerReference,
    isHappyToBeAutoSwitched: process.env.VUE_APP_HAPPY_TO_BE_AUTO_SWITCH === 'true',
    accountManagementOnline: 'UnInterested',
    newTariffPaymentMethod: state.newTariffPaymentMethod
  };

  const paymentMethods = [state.electricityCurrentPayMethod, state.gasCurrentPayMethod, state.currentPayMethod];

  if (paymentMethods.indexOf('prePaymentMeter') > -1) {
    modelObject.newTariffPaymentMethod = 'prePaymentMeter';
  }

  switch (quoteType) {
    case 'gasToGas':
      return {
        ...modelObject,
        tariffId: state.gasTariff.id,
        tariffValidToDate: state.gasTariffValidToDate,
        currentPayMethod: state.gasCurrentPayMethod,
        utilityPeriod: 'Annually',
        currentCostEstimated: convertToYearly(state.gasUsage.cost, state.gasUsage.usageUnit),
        currentUsageEstimated: convertToYearly(state.gasUsage.usage, state.gasUsage.usageUnit)
      };

    case 'electricityToElectricity':
      return {
        ...modelObject,
        tariffId: state.electricityTariff.id,
        tariffValidToDate: state.electricityTariffValidToDate,
        currentPayMethod: state.electricityCurrentPayMethod,
        utilityPeriod: 'Annually',
        currentCostEstimated: convertToYearly(state.electricityUsage.cost, state.electricityUsage.usageUnit),
        currentUsageEstimated: convertToYearly(state.electricityUsage.usage, state.electricityUsage.usageUnit)
      };

    case 'dualDistinctToDualConsolidated':
      return {
        ...modelObject,
        electricityConsumptionExceedsGasConsumption: electricityUsage > gasUsage,
        electricityTariffId: state.electricityTariff.id,
        electricityTariffValidToDate: state.electricityTariffValidToDate,
        electricityCurrentPayMethod: state.electricityCurrentPayMethod,
        electricityUtilityPeriod: 'Annually',
        electricityCurrentCostEstimated: convertToYearly(state.electricityUsage.cost, state.electricityUsage.usageUnit),
        electricityCurrentUsageEstimated: convertToYearly(state.electricityUsage.usage, state.electricityUsage.usageUnit),
        gasTariffId: state.gasTariff.id,
        gasTariffValidToDate: state.gasTariffValidToDate,
        gasCurrentPayMethod: state.gasCurrentPayMethod,
        gasUtilityPeriod: 'Annually',
        gasCurrentCostEstimated: convertToYearly(state.gasUsage.cost, state.gasUsage.usageUnit),
        gasCurrentUsageEstimated: convertToYearly(state.gasUsage.usage, state.gasUsage.usageUnit)
      };

    case 'dualConsolidatedToDualConsolidated':
      return {
        ...modelObject,
        electricityConsumptionExceedsGasConsumption: electricityUsage > gasUsage,
        tariffId: state.tariff.id,
        tariffValidToDate: state.tariffValidToDate,
        currentPayMethod: state.currentPayMethod,
        utilityPeriod: 'Annually',
        electricityCurrentCostEstimated: convertToYearly(state.electricityUsage.cost, state.electricityUsage.usageUnit),
        electricityCurrentUsageEstimated: convertToYearly(state.electricityUsage.usage, state.electricityUsage.usageUnit),
        gasCurrentCostEstimated: convertToYearly(state.gasUsage.cost, state.gasUsage.usageUnit),
        gasCurrentUsageEstimated: convertToYearly(state.gasUsage.usage, state.gasUsage.usageUnit)
      };

    default:
      return {
        ...modelObject,
        tariffId: state.gasTariff.id,
        tariffValidToDate: state.gasTariffValidToDate,
        currentPayMethod: state.gasCurrentPayMethod,
        utilityPeriod: 'Annually',
        currentCostEstimated: convertToYearly(state.gasUsage.cost, state.gasUsage.usageUnit),
        currentUsageEstimated: convertToYearly(state.gasUsage.usage, state.gasUsage.usageUnit)
      };
  }
}

function convertToYearly(usageCost, usageUnit) {
  const multipliers = [0, 1, 12, 4];
  if (!usageCost) return null;

  return Number(usageCost) * multipliers[usageUnit];
}
